export default {
    subText: '0.625rem',
    extraSmall: '0.75rem',
    small: '1rem',
    medium: '1.5rem',
    large: '1.75rem',
    extraLarge: '2rem',
};
